import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.empty');
import { OnInit, Input } from '@angular/core';

@Component({
    selector: 'wiz-layout-empty',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.empty/view.scss */
/* src/app/layout.empty/view.scss: no such file or directory */`],
})
export class LayoutEmptyComponent implements OnInit {
    @Input() title: any;

    public async ngOnInit() {
    }
}

export default LayoutEmptyComponent;